import { defineComponent as _defineComponent } from 'vue'
import { Affiliate } from "@/services/affiliates/Affiliate";
import AffiliateMainInfo from "@/components/affiliate/affiliateMainInfo/AffiliateMainInfo.vue";
import AffiliateNotes from "@/components/affiliate/AffiliateNotes.vue";
import AffiliateBalance from "@/components/affiliate/AffiliateBalance.vue";
import AffiliateStatistic from "@/components/affiliate/AffiliateStatistic.vue";
import AffiliatePaymentInfo from "@/components/affiliate/AffiliatePaymentInfo.vue";
import TaskOnTargetDetail from "@/components_v3/tasks/TaskOnTargetDetail.vue";

interface Props {
    affiliate: Affiliate;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateSingle',
  props: {
    affiliate: null
  },
  emits: ["update-affiliate"],
  setup(__props: any, { emit }) {

const props = __props as {
    affiliate: Affiliate;
}




return { __sfc: true,props, emit, AffiliateMainInfo, AffiliateNotes, AffiliateBalance, AffiliateStatistic, AffiliatePaymentInfo, TaskOnTargetDetail }
}

})